<template>
  <!--  <a-skeleton :loading="loading" active :paragraph="{width:'100%',rows:5}" :title="false">-->
  <div>
    <a-spin :spinning="loading">
      <div class="pt-simple-table">
        <el-table :data="dataSource"  v-bind="$attrs"  header-row-class-name="pt-table-header" :height="height" :refs="refs"
                  :row-key="rowKey" @sort-change="sortChange" @selection-change="selectionChange" @row-click="rowClick"
                  :highlight-current-row="tableHighlight" :header-cell-class-name="handleTheadAddClass">
          <el-table-column
            v-if="showIndex"
            type="index"
            label=""
            width="60"
          />
          <slot name="columns"></slot>

          <div slot="empty">
            <slot name="empty"  v-if="$slots.empty">{{$t('baseVO.empty')}}</slot>
            <div  class="emptyDiv"  v-if="!$slots.empty">
              <pt-empty  :description="description?description:$t('baseVO.empty')" ></pt-empty>
            </div>
          </div>
          <div slot="append">
            <slot name="append"></slot>
          </div>
        </el-table>
      </div>
      <div class="table-pagination"  v-show="total > 0 &&　total > pagination.pageSize">
        <a-pagination size="small" :current="pagination.current" @change="tablePageChange"  :hideOnSinglePage="true"  :pageSize="pagination.pageSize" :total="pagination.total" :showTotal="pagination.showTotal" />
      </div>
    </a-spin>

  </div>

  <!--  </a-skeleton>-->
</template>

<script>

  import { mapState } from 'vuex'

  export default {
    name: 'ptSimpleTable',
    props:{

      dataSource:{
        type:Array,
        default:()=>{return []}
      },
      refs:{
        type:String,
        default:'table'
      },
      showIndex:{
        type:Boolean,
        default: false,
      },
      rowKey:{
        type:String,
        default:'id'
      },
      height:{
        default:null
      },
      total:{
        default:1,
      },
      current:{
        default:1,
      },
      sortVO:{
        type:Object,
        default:null,
      },
      size:{
        default:10,
      },
      loading:{
        type:Boolean,
        default: true,
      },
      showAdd:{
        type:Boolean,
        default:true,
      },
      description:{
        type:String,
        default:null,
      },
    },
    data(){
      return {
        searchText:'',
        pagination:{
          pageSize:this.size,
          total:1,
          size:'small',
          current:1,
          hideOnSinglePage:true,
          showTotal:(total)=>{
            return `共${total}条`
          }
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.repairMissingColumns()
      })
    },
    updated() {
      this.$nextTick(() => {
        this.repairMissingColumns()
      })
    },
    watch:{
      current(newValue){
        console.log(newValue)
        this.pagination.current = newValue
      },
      total(newValue){
        this.pagination.total = newValue
      },
      size(newValue){
        this.pagination.pageSize = newValue
      },
    },
    computed: {
      ...mapState({
        tableHighlight: state => state.app.tableHighlight
      })
    },
    methods:{
      collectTableColumnComponents(children = []) {
        let result = []
        children.forEach(child => {
          if (!child) {
            return
          }
          if (child.$options && child.$options.name === 'ElTableColumn') {
            result.push(child)
          }
          if (child.$children && child.$children.length) {
            result = result.concat(this.collectTableColumnComponents(child.$children))
          }
        })
        return result
      },
      repairMissingColumns() {
        const table = this.$refs[this.refs]
        if (!table || !table.store || !table.store.states) {
          return
        }
        const currentColumns = table.store.states._columns || []
        if (currentColumns.length > 0) {
          return
        }
        const columns = this.collectTableColumnComponents(this.$children)
        if (!columns.length) {
          return
        }
        columns.forEach(column => {
          if (!column || !column.columnConfig) {
            return
          }
          const parent = column.columnOrTableParent
          if (!parent) {
            return
          }
          const isSubColumn = !!column.isSubColumn
          const children = isSubColumn && parent.$el
            ? parent.$el.children
            : (table.$refs.hiddenColumns ? table.$refs.hiddenColumns.children : [])
          const columnIndex = typeof column.getColumnElIndex === 'function'
            ? column.getColumnElIndex(children, column.$el)
            : undefined
          table.store.commit(
            'insertColumn',
            column.columnConfig,
            columnIndex,
            isSubColumn ? parent.columnConfig : null
          )
        })
        if (typeof table.store.updateColumns === 'function') {
          table.store.updateColumns()
        }
        if (typeof table.doLayout === 'function') {
          table.doLayout()
        } else if (typeof table.store.scheduleLayout === 'function') {
          table.store.scheduleLayout()
        }
      },
      handleTheadAddClass({row, column, rowIndex, columnIndex}){
        if(this.sortVO){
          if(this.sortVO.orderColumn != null && this.sortVO.orderColumn != undefined && this.sortVO.orderColumn.indexOf(column.property) > -1){
            if(this.sortVO.orderValue == 'ASC'){
              return  'ascending';
            }else{
              return 'descending';
            }
          }
        }
      },
      clickEvent(){
        this.$emit('add')
      },
      //获取表格refs对象
      getTableRefs(){
        return this.$refs[this.refs];
      },
      searchEvent(){
        this.$emit('search',this.searchText)
      },

      selectionChange(selection){
        this.$emit('selection-change',selection)
      },
      rowClick(row,column,event){
        this.$emit('rowClick',row,column,event)
      },
      sortChange( {column, prop, order}){
        console.log(column,prop,order)
        if(order){
          let orderValue = order.replace('ending','').toUpperCase()
          this.$emit('sort-change',prop, orderValue)
        }else{
          this.$emit('sort-change')
        }

      },
      // sortChange( {column, prop, order}){
      //   this.$emit('sort-change',{column, prop, order})
      // },
      tablePageChange(page,pageSize){
        console.log(page,pageSize)
        this.$emit('tablePageChange',page,pageSize)
        this.pagination.current = page
      },

    }
  }
</script>

<style scoped lang="less">
  @import "../../core/diy";

  .table-pagination{
    margin-top: 20px;
    text-align: right;
    padding-bottom: 20px;
  }

  .pt-simple-table /deep/ .el-table__row:hover td{
   background-color: @table-row-hover-bg !important;
  }

  .pt-simple-table{
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: @primary-color;
      border-color: @primary-color;
    }
    /deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
      border-color: @primary-color;
    }
    /deep/ .pt-table-header{
      th >.cell{
        color: @text-color-9;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .emptyDiv{
    padding-top: 10px;
    padding-bottom: 10px;
  }

</style>
